import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Modal, DatePicker, message } from 'antd'
import moment from 'moment'
import './../../ui.style.scss'
import { isEqual } from 'lodash'
import DropDown from '../inputs/DropDown'
// import { utilityService } from 'services/UtilityService'

const errorMessages = [
  `Password doesn't match`,
  `Password must be atleast 8 characters`,
  `Password must have atleast one number`,
  `Password must have atleast one letter`
]

/// const isProd = utilityService.getEnvironment() === ''
let selectOptions = [
  { name: 'optus_venue', value: 'optus_venue' },
  { name: 'bein_venue', value: 'bein_venue' }
]

// if (isProd) {
//   selectOptions = [
//     { name: 'optus_venue', value: 'optus_venue' }
//   ]
// }

class CreateVenueSubscriptionModal extends Component {
  constructor (props) {
    super(props)
    this.state = {
      offerCode: 'optus_venue',
      endDate: '',
      isEdited: false,
      isendDateError: false,
      errorMessage: errorMessages[0]
    }
  }

  UNSAFE_componentWillReceiveProps = nextProps => { // eslint-disable-line camelcase
    const { data } = nextProps
    if (!this.state.isEdited && data && data.email) {
      this.setState({
        email: data.email
      })
    }
  }

  componentDidUpdate (prevProps) {
    const { offerCode } = this.props
    const { offerCode: prevOfferCode } = prevProps
    if (!isEqual(prevOfferCode, offerCode)) {
      this.setState({
        offerCode
      })
    }
  }

  handleChangeOfferCode = selectedValue => {
    this.setState({ offerCode: selectedValue, isEdited: true })
  }

  handleSubmit = () => {
    const { email, offerCode, endDate } = this.state
    if (!endDate) {
      message.warn('Empty End Date')
      return
    }
    const data = {
      email,
      offerCode,
      endDate
    }
    this.props.handleSubmit(data)
  }

  onChangeDOB = endDate => {
    this.setState({ endDate, isEdited: true })
  }

  clearState = () => {
    this.setState({
      endDate: '',
      offerCode: '',
      isEdited: false
    })
  }

  render () {
    const { isVisible, isSubmitDisabled, handleCancel, isLoading } = this.props
    const { isEdited, offerCode, endDate } = this.state
    return (
      <Modal
        className='general-modal create-subscription-modal'
        title={'CREATE SUBSCRIPTION'}
        maskClosable={false}
        visible={isVisible}
        okText='Create'
        cancelText='Cancel'
        onOk={this.handleSubmit}
        onCancel={handleCancel}
        okButtonProps={{ disabled: isSubmitDisabled || !isEdited || !endDate }}
        closable={false}
        centered
        destroyOnClose
        confirmLoading={isLoading}
        afterClose={this.clearState}
        width='350'>
        {isVisible ? (
          <div className='create-subscription-container' id='create-subscription-container'>
            <div className='offer-code-wrapper'>
              <label>Offer Code</label>
              <DropDown
                options={selectOptions}
                onOptionSelect={this.handleChangeOfferCode}
                selectedValue={offerCode}
                valueParam='value'
                displayParam='name'
                placeHolder='Select '
                parent={'create-subscription-container'}
              />
            </div>

            {/* <Input
              title='Offer Code'
              inputName='offerCode'
              handleChange={this.handleChangeOfferCode}
              value={offerCode}
              placeholder='Enter Offer Code'
              type={'text'}
              errorMessage='Please enter offer code'
              readOnly={isOfferCodeReadOnly}
            /> */}

            <div className='date-picker-container'>
              <label>End Date</label>
              <DatePicker
                value={endDate ? moment(endDate) : null}
                format='DD MMM YYYY'
                onChange={this.onChangeDOB}
                placeholder='Select end date'
                allowClear
                timeDisabled
              />
            </div>
          </div>
        ) : null}
      </Modal>
    )
  }
}

CreateVenueSubscriptionModal.propTypes = {
  /** Visible status of Modal. */
  isVisible: PropTypes.bool,
  /** Callback when content is saved */
  handleSubmit: PropTypes.func,
  /** Callback when cancel is clicked */
  handleCancel: PropTypes.func,
  /** Boolean to disable submit button */
  isSubmitDisabled: PropTypes.bool
}

export default CreateVenueSubscriptionModal
